import ComposerBody from 'flarum/components/ComposerBody';
import Link from 'flarum/common/components/Link';
import icon from 'flarum/common/helpers/icon';
import replaceContent from "../helpers/replaceContent";
import isFunction from "../helpers/isFunction";

function minimizeComposerIfFullScreen(e) {
  if (app.composer.isFullScreen()) {
    app.composer.minimize();
    e.stopPropagation();
  }
}

export default class AdvCommentEditor extends ComposerBody {
  oninit(vnode) {
    super.oninit(vnode);
    this.comment = this.attrs.comment;
    this.ctx = this.attrs.ctx;
  }

  static initAttrs(attrs) {
    super.initAttrs(attrs);

    attrs.submitLabel = attrs.submitLabel || app.translator.trans('tolyod-advdiscus.forum.composer_edit.submit_button');
    attrs.confirmExit = attrs.confirmExit || app.translator.trans('tolyod-advdiscus.forum.composer_edit.discard_confirmation');
    attrs.originalContent = isFunction(attrs.comment.content) ? attrs.comment.content() : attrs.comment.content;
    attrs.user = attrs.user || attrs.post.user();

  }

  data() {
    return {
      content: this.composer.fields.content(),
    };
  }

  onsubmit(newCommentText) {
    this.loading = true;
/*     const updatedAdvCommentRecord = app.store.getById('advcomments', this.comment.id); */
    const updatedAdvCommentRecord = this.comment;

    updatedAdvCommentRecord
      .save(this.data())
      .then((r) => {
        this.comment.content = newCommentText;
        this.composer.hide();
        // console.log(r, this.ctx.postComments());

        app.current.get('stream').update();
        this.loading = false;
        m.redraw();

      }, this.loaded.bind(this)
      );
    return false;
  }

  headerItems() {
    const items = super.headerItems();
    const post = this.attrs.post;

    items.add(
      'title',
      <h3>
        {icon('fas fa-pencil-alt')}{' '}
        {/*
        <Link href={app.route.discussion(post.discussion(), post.number())} onclick={minimizeComposerIfFullScreen}>
          {app.translator.trans('core.forum.composer_edit.post_link', { number: post.number(), discussion: post.discussion().title() })}
        </Link>
        */}
      </h3>
    );

    return items;
  }
}
